import type { User } from "@/api/userService";
import type { UserInfoType } from "@/context/UserInfoContext";

export const checkIsBuyer = (user: User | UserInfoType | null | undefined): boolean => {
  if (!user) return false;
  return (
    user.buyer_code !== null && !["555", "999"].includes(user.buyer_code.trim())
  );
};
